module.exports = __webpack_public_path__ + "static/media/user-icon2.6f6bbb16.png";